<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: getMetaAttr('navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <router-view></router-view>
  </nuttrema-layout-west-slide>
</template>

<script>
import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import PageProps from 'components/mixins/page-props';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';


export default {
  name: 'page-search-overflow',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/search-east/page-search-overflow.vue